import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dodao-ui/dodao-ui/academy-ui/src/app/courses/view/[...courseInfo]/CourseInformation.tsx");
